// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__12gTl","content":"ManualTimeModal_content__oRtfD"};